import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChallengeActivityQuery } from '@examdojo/challenge';
import { QuestionAttemptEntityQuery, QuestionAttemptEntityService } from '@examdojo/question';
import { SolutionCaptureService } from '@examdojo/solution';
import { distinctUntilChanged, filter, finalize, merge, Observable, tap } from 'rxjs';

@Injectable()
export class CloseSolutionCaptureDialogChallengeEffectService {
  constructor(
    private readonly solutionCaptureService: SolutionCaptureService,
    private readonly questionAttemptQuery: QuestionAttemptEntityQuery,
    private readonly questionAttemptService: QuestionAttemptEntityService,
    private readonly challengeActivityQuery: ChallengeActivityQuery,
  ) {
    merge(
      this.shouldCloseSolutionCaptureDialogOnAttemptStatusChange(),
      this.shouldCloseSolutionCaptureDialogOnActivityChange(),
    )
      .pipe(
        finalize(() => {
          if (this.solutionCaptureService.isDialogOpen()) {
            this.solutionCaptureService.dismiss();
          }
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  readonly activeChallengeActivityId$: Observable<string | null> =
    this.challengeActivityQuery.activeChallengeActivityId$;

  shouldCloseSolutionCaptureDialogOnAttemptStatusChange() {
    return this.questionAttemptQuery.attemptStatus$.pipe(
      distinctUntilChanged(),
      filter((status) => !!status && status !== 'PENDING'),
      tap((status) => {
        if (status === 'GRADED' || status === 'FAILED') {
          this.questionAttemptService.setOpenCaptureDialogFlag(false);
          this.solutionCaptureService.dismiss();
        }
      }),
    );
  }

  shouldCloseSolutionCaptureDialogOnActivityChange() {
    return this.activeChallengeActivityId$.pipe(
      distinctUntilChanged(),
      tap((activeChallengeActivityId) => {
        if (!activeChallengeActivityId) {
          this.questionAttemptService.setOpenCaptureDialogFlag(false);
          this.solutionCaptureService.dismiss();
        }
      }),
    );
  }
}
